module.exports = __webpack_public_path__ + "static/media/c1.5557bfce.jpg";